import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import logoImg from '../img/logo-full.png'
import minilogoImg from '../img/logo.png'
import SpaIcon from '@mui/icons-material/Spa';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import logoIcon from '../img/logo.png';
import { formatPrice } from '../helper/functions';



function Sidebar({commonStats}) {
    const handleToggle = () => {
        document.body.classList.toggle('toggle-sidebar');
    }

    return (
        <>
            <aside className="sidebar">
                <div className='sidebar-line'>
                    <div className="sidebar-logo d-flex align-items-center justify-content-between">
                        <a href="#sec" class="header-logo">
                            {/* <img src="assets/images/logo.svg" class="img-fluid light-logo" alt="logo" /> */}
                            <img src={logoImg} className='big-logo' height="40px" width="auto" alt='logo' />
                            <img src={minilogoImg} className='mini-logo' height="40px" width="40px" alt='logo' />
                        </a>
                        <div className="menu-bt-sidebar" style={{ cursor: "pointer" }} onClick={() => handleToggle()}>
                            <MenuOpenOutlinedIcon sx={{ color: "white" }} fontSize='large' />
                        </div>
                    </div>
                </div>
                <div className='sidebar-menu'>
                    <ul className="sidebar-menu-nav">
                        <li>
                            <a href="https://kingofmoney.io/" target='_blank' rel="noreferrer">
                                <DashboardIcon sx={{ color: "#fff" }} className='me-2' />
                                <span>Website</span>
                            </a>
                        </li>
                        <li>
                            <a href="#sec" className='active'>
                                <EmojiEventsIcon sx={{ color: "#FCD535" }} className='me-2' />
                                <span>Staking</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://gmntswap.finance/swap/" target='_blank' rel="noreferrer">
                                <LayersOutlinedIcon sx={{ color: "#fff" }} className='me-2' />
                                <span>Exchange</span>
                            </a>
                        </li>
                        <li>
                            <a href="#sec" target='_blank' rel="noreferrer">
                                <SpaIcon sx={{ color: "#fff" }} className='me-2' />
                                <span>Wallet</span>
                            </a>
                        </li>
                        <li>
                            <a href="#sec" target='_blank' rel="noreferrer">
                                <CoPresentIcon sx={{ color: "#fff" }} className='me-2' />
                                <span>BlockChain</span>
                            </a>
                        </li>
                    </ul>

                </div>
                <div className='d-flex align-items-center gap-2 justify-content-center border-top pt-2 my-3'>
                    <img src={logoIcon} height="30px" width="30px" alt='logo' />
                    <span className='fs-6'>${formatPrice(commonStats.getTokenPrice)}</span>
                    <a href='https://gmntswap.finance/swap/?outputCurrency=0x807e24398591DC7AaB77E2E19dAcC40Ac6d18dF5' rel="noreferrer" target='_blank'  className='btn btn-warning btn-periods mx-1 py-1 mb-3 mb-md-0'>Buy Now</a>
                </div>
            </aside>
        </>
    )
}
export default Sidebar